import React from 'react';

const Vegeterian = () => {
  const menuItems = [
    {
      id: 1,
      name: 'Shiro Wot || Chickpea Stew',
      description: 'Ground roasted yellow split peas cooked in berbere sauce.',
      image: '/shiro.jpeg', // Replace with the actual image URL
    },
    {
      id: 2,
      name: 'Gomen Wot || Collard Greens Stew ',
      description: 'A stewed mixture of Greens.',
      
      image: '/gomentsom.jpeg', // Replace with the actual image URL
    },
    {
        id: 3,
        name: 'Tekil Gomen || Vegetarian Cabbage ',
        description: 'Delicious curried Ethiopian cabbage and carrots vegetable stew made with carrots, potatoes, cabbage, peppers, and onions.',
       
        image: '/Tikil-Gomen-3-768x432-1-e1634369724674.jpg', // Replace with the actual image URL
      },
      {
        id: 4,
        name: 'Timatim Fitfit || Tomato ',
        description: 'Timatim is a delightful little tomato side salad often served on top of Injera.',
        price: '$10.99',
        image: '/timatim.jpeg', // Replace with the actual image URL
      },
      {
        id: 5,
        name: 'Difin YeMisir Azifa || Chilled Pureed Lentils ',
        description: 'Chilled pureed lentils harmoniously blended with spices & herbs.',
        price: '$10.99',
        image: '/shiro.jpeg', // Replace with the actual image URL
      },
    {
      id: 6,
      name: 'Yetsom Beyayinetu || Vegetable Compo',
      description: 'Fresh vegetables stir-fried in a savory sauce.',
      price: '$9.99',
      image: '/beyayinetu.jpeg', // Replace with the actual image URL
    },
  ];

  return (
    <div className=" py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-semibold text-center mb-8">Vegeterian Menu</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="bg-amber-400 rounded-lg p-6 shadow-lg transition-transform transform hover:scale-105"
            >
              <img
                src={item.image}
                alt={item.name}
                className="w-full h-auto object-cover mb-4 rounded"
              />
              <h3 className="text-xl text-center font-semibold mb-2">{item.name}</h3>
              <p className="text-gray-600 text-center mb-4">{item.description}</p>
           
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Vegeterian;
